import { FiArrowUp, FiPaperclip, FiX } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import MicButton from './MicButton';
import FilePreview from './FilePreview';

export default function ChatComposer({ question, setQuestion, inputRef, onSubmit, onKeyDown, disabled,
  busy, placeholder, exampleLabel, mode, file, onRemoveFile, files, onRemoveDocument,
  uploading, isFileMode, fileInputRef, documentsInputRef, onFileChange, onDocumentsChange,
  accept, onDragOver, onDragLeave, onDrop, dragging, organ, setOrgan, answerMode, onAnswerModeChange,
  submissionUnavailable = false, structured = false, pendingFiles = [], compact = false }) {
  const { t } = useTranslation('workspace');
  const attachments = [...(file ? [{ id: 'image', file, remove: onRemoveFile }] : []),
    ...files.map((item) => ({ id: item.id, file: item, remove: () => onRemoveDocument(item.id) })),
    ...pendingFiles.map((item) => ({ id: item.id, file: item }))];
  return <form className={`ws-composer${exampleLabel ? ' ws-composer-example' : ''}${compact ? ' ws-composer-compact' : ''}`} onSubmit={onSubmit} onDragOver={onDragOver} onDragLeave={onDragLeave} onDrop={onDrop}>
    {dragging && mode === 'default' && <div className="chat-drop-overlay">{t('attach')}</div>}
    {(attachments.length > 0 || uploading) && <div className="ws-attachments" aria-live="polite">
      {attachments.map((item) => <div className="ws-attachment" key={item.id}>
        <FilePreview file={item.file} />
        {item.remove && <button className="ws-attachment-remove" type="button" onClick={item.remove} aria-label={t('remove', { name: item.file.name })}><FiX /></button>}
      </div>)}
      {uploading && <span className="ws-muted">{t('uploading')}</span>}
    </div>}
    {exampleLabel && <span className="ws-composer-example-label">{exampleLabel} :</span>}
    <textarea ref={inputRef} rows={compact ? 1 : 2} value={question} onChange={(event) => setQuestion(event.target.value)}
      onKeyDown={onKeyDown} placeholder={placeholder || t('conversationHint')} aria-label={t('question')}
      disabled={disabled} required={!file && files.length === 0} />
    {file && mode === 'plantnet' && <label className="ws-organ">{t('organ')}<select value={organ} onChange={(event) => setOrgan(event.target.value)}>
      {['auto', 'leaf', 'flower', 'fruit', 'bark'].map((value) => <option key={value} value={value}>{t(value)}</option>)}
    </select></label>}
    <div className="ws-composer-actions">
      {!structured ? <label className="ws-answer-select">
        <span className="ws-sr-only">{t('answerLength')}</span>
        <select value={answerMode} disabled={disabled || busy} onChange={(event) => onAnswerModeChange(event.target.value)}>
          <option value="flash">{t('answerFlash')}</option>
          <option value="detailed">{t('answerDetailed')}</option>
        </select>
      </label> : <span />}
      <div className="ws-composer-utilities">
        {(mode === 'default' || (isFileMode && !file)) && <button className="ws-icon-button" type="button" title={t('attach')} aria-label={t('attach')} disabled={uploading || disabled || busy || submissionUnavailable}
          onClick={() => (mode === 'default' ? documentsInputRef : fileInputRef).current?.click()}><FiPaperclip /></button>}
        <input hidden type="file" ref={documentsInputRef} multiple accept={accept} onChange={onDocumentsChange} />
        <input hidden type="file" ref={fileInputRef} accept={mode === 'labo' ? 'image/*,.pdf,application/pdf' : 'image/*'} onChange={onFileChange} />
        <MicButton disabled={disabled || submissionUnavailable} title={t('dictate')} onTranscribe={(text) => setQuestion((previous) => previous ? `${previous} ${text}` : text)} />
        <button className="ws-send" type="submit" aria-label={t('send')} title={t('send')} disabled={disabled || busy || uploading || submissionUnavailable}><FiArrowUp /></button>
      </div>
    </div>
  </form>;
}
